<template>
  <basic-container>
    <div style="bossDiv">
      <div v-for="(item, index) in projectList" :key="index" class="jumpDiv">
        
          <el-button type="primary" size="small" value="item.id" @click="jump(value)">
            {{ item.name }}
          </el-button>

          <el-button type="danger" size="small" value="item.id" @click="jumpToOther(value)">
            {{ item.name }}
          </el-button>
        
      </div>
    </div>
  </basic-container>
</template>

<script>
import { getProjectList } from '@/api/crmedical/project/project';

export default {
  data() {
    return {
      projectList: [],
    };
  },
  methods: {
    jump(value) {
      location.href =
        'https://rpt-test.pms1.cn/webroot/decision/view/form?viewlet=xhHospitalbak.frm&projectId=' +
        value;
    },
    jumpToOther(value) {
      window.open(
        'https://rpt-test.pms1.cn/webroot/decision/view/form?viewlet=xhHospitalbak.frm&projectId=' +
          value
      );
    },
    initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;
        console.log(this.projectList);
      });
    },
  },
  created() {
    this.initData();
  },
};
</script>

<style >
    .bossDiv{
        height: 400px;
        width: 400px;
        overflow-y:scroll;
        overflow-x:scroll;
        overflow: auto;
    }
    .jumpDiv{
        display: flex;
        justify-content: space-between;
        width: 400px;
        padding:5px;
    }
</style>